import { useState, useEffect } from 'react'
import { getTenant, getToken } from '../../../utils'
import Spinner from '../../Spinner/Spinner'

export default function LossSettlementFundingRequestPDF({ location }) {
  console.log('LossSettlementFundingRequestPDF rendered')
  const tenant = getTenant()
  const [jwt, setJwt] = useState()
  
  useEffect(() => {
    function tokenSuccess(jwt) {
      setJwt(jwt)
    }
    function tokenError(error) {
      console.log('in token error', error)
    }
    getToken(tokenSuccess, tokenError)
  }, [])

  if (jwt) {
    const params = new URLSearchParams(location.search)
    const inputs = params.get('inputs')
    return (
      <div style={{
        display: 'inline',
        //position: 'absolute',
        top: '0px',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
      }} height="100%">
        <iframe title="bottom" width="100%" height="100%" src={`${process.env.REACT_APP_SERVER}/pdf/${tenant}/custom/Asbestos/lossSettlementPDF/loss_settlement.pdf?inputs=${inputs}&jwt=${jwt}`} ></iframe>
      </div>
    )
  } else {
    return <Spinner />
  }
}